module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.13507/img/homepage-header-image.png"